<template>
    <vueper-slides
    class="no-shadow"
    :visible-slides="4.5"
    slide-multiple
    :gap="3"
    :slide-ratio="1 / 4"
    :dragging-distance="200"
    :bullets="false"
    :breakpoints="breakpoints"
    disable-arrows-on-edges
    >
        <vueper-slide v-for="(slide, i) in slides"
            :key="i"
            :name="slide.name"
            :image="slide.image"
            :title="slide.title"
            :link="slide.link"
        >
            <template #content>
                <div class="content">
                    <p>{{slide.title}}</p>
                    <i class="fa fa-chevron-right"></i>
                </div>
            </template>

        </vueper-slide>
    </vueper-slides>
</template>

<script>
    import { VueperSlides, VueperSlide } from 'vueperslides';
    import 'vueperslides/dist/vueperslides.css';

    export default {
        components: { VueperSlides, VueperSlide },
        data: () => ({
            breakpoints: {
                1200: {
                slideRatio: 1 / 5,
                visibleSlides: 5, slideMultiple: 5
                },
                900: {
                slideRatio: 1 / 3,
                visibleSlides: 3, slideMultiple: 3
                },
                600: {
                slideRatio: 1 / 2,
                visibleSlides: 2, slideMultiple: 2,
                arrows: false
                }
            },

            slides: [
                {
                    name: 'Product #1',
                    title: 'Product 1 title.',
                    image: 'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com-dev/images/products/_productDetail/69968/9552_112.webp',
                    link: 'https://asc-es.imarc.io/'
                },
                {
                    name: 'Product #2',
                    title: 'Product 2 title.',
                    image: 'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com-dev/images/products/_productDetail/69968/9552_112.webp',
                    link: 'https://asc-es.imarc.io/'
                },
                {
                    name: 'Product #3',
                    title: 'API 608 Ball Valves',
                    image: 'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com-dev/images/products/_productDetail/69968/9552_112.webp',
                    link: 'https://asc-es.imarc.io/'
                },
                {
                    name: 'Product #4',
                    title: 'Ball Valves, 3-Piece, CWP Rated',
                    image: 'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com-dev/images/products/_productDetail/69968/9552_112.webp',
                    link: 'https://asc-es.imarc.io/'
                },
                {
                    name: 'Product #3',
                    title: 'API 608 Ball Valves',
                    image: 'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com-dev/images/products/_productDetail/69968/9552_112.webp',
                    link: 'https://asc-es.imarc.io/'
                },
                {
                    name: 'Product #4',
                    title: 'API 608 Ball Valves',
                    image: 'https://s3.us-east-1.amazonaws.com/ue1.asc-es.com-dev/images/products/_productDetail/69968/9552_112.webp',
                    link: 'https://asc-es.imarc.io/'
                },
            ],

        })
    }


</script>